import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 工具函数：判断登录端
function isMobile() {
  const ua = navigator.userAgent
  console.log('123',/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua))
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
}

// PC
import home from '../page/pc/home.vue';
import about from '../page/pc/about.vue';
import solutions from '../page/pc/solutions.vue';
import technology from '../page/pc/technology.vue';
import locations from '../page/pc/locations.vue';
import franchise from '../page/pc/franchise.vue';
import contact from '../page/pc/contact.vue';
import blogs from '../page/pc/blogs.vue';
import blogsDetail from '../page/pc/blogsDetail.vue';
import seach from '../page/pc/seach.vue'
import form from '@/page/pc/form.vue'
// MOBILE
import aboutMo from '../page/mobile/about.vue';
import solutionMo from '../page/mobile/solutions.vue';
import technologyMo from '../page/mobile/technology.vue';
import locationsMo from '../page/mobile/locations.vue';
import franchiseMo from '../page/mobile/franchise.vue';
import contactMo from '../page/mobile/contact.vue';
import blogsMo from '../page/mobile/blogs.vue';
import seachMo from '../page/mobile/seach.vue'
import formMo from '@/page/mobile/form.vue'
import blogsDetailMo from '@/page/mobile/blogsDetail.vue'

// const routes = [
//   { path: '/', component: home },
//   { path: '/page/pc/about', component: about },
//   { path: '/page/pc/solutions', component: solutions },
// ];
// 首页判断
const HomeAsync = () => isMobile()
  ? import('@/page/mobile/home.vue')
  : import('@/page/pc/home.vue')
const routes = [
  { path: '/', component: ()=> HomeAsync() },
  { path: '/about', component: isMobile() ? aboutMo : about },
  { path: '/solutions',name:'solutions', component: isMobile() ? solutionMo : solutions },
  { path: '/technology', component: isMobile() ? technologyMo : technology },
  { path: '/locations', component: isMobile() ? locationsMo : locations },
  { path: '/franchise', component: isMobile() ? franchiseMo : franchise },
  { path: '/contact', component: isMobile() ? contactMo : contact },
  { path: '/blogs', name: 'blogs', component: isMobile() ? blogsMo : blogs },
  { path: '/seach', component: isMobile() ? seachMo : seach },
  { path: '/form', component: isMobile() ? formMo : form },
  { path: '/detail', name: 'detail', component: isMobile() ? blogsDetailMo : blogsDetailMo },
  {
    path: '/blogsDetail/:id/:type',
    name: 'blogsDetail',
    component: isMobile() ? blogsDetail : blogsDetail,
    props: (route) => ({
      id: String(route.params.id),
      type: route.params.type
    })
  },
];
console.log('routes',routes)

const router = new VueRouter({
  mode: 'hash', // 使用HTML5 History模式
  routes,
});
// 在这里添加 afterEach 导航守卫
router.afterEach((to, from) => {
  // 每次路由跳转后都滚动到顶部
  window.scrollTo(0, 0);
});
export default router;